import React from 'react'
import {getProductBatch, enablePickingStatus, disablePickingStatus} from "../../utilityFunctions/WarehouseUtil";
import { Button, Typography, Box, Grid, TextField, Divider} from "@mui/material";
import Colors from "../../components/ui/Colors";
import { css } from "@emotion/react";
import swal from 'sweetalert';
import { PuffLoader } from "react-spinners";
import { useHistory } from 'react-router-dom';

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const dateOptions = {
    // weekday: "short",
    day: "numeric",
    month: "numeric",
    year: "numeric",
};

const enablePickingRequest ={};

export default function LabelReaderPicking(props) {

    const{loginUser} = props;

    let history = useHistory();

    const [loading, setLoading] = React.useState(false);

    const[productResponse, setProductResponse] = React.useState(null);

    const[disableButton, setDisableButton] = React.useState(true);

    const [qrInput, setQrInput] = React.useState("");

    const qrInputChange = async (e) => {
        
        const value = e.target.value.replace(/\D/g, '');
        console.log(value);
        setQrInput(value)
        enablePickingRequest.id= value;
        setDisableButton(false);
    }

    const qrInputSubmit = async() => {
        
        enablePickingRequest.username=loginUser.accountId;
        
        setLoading(true);
        const response = await getProductBatch(enablePickingRequest, loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Código errado",
                text: "El código ingresado es incorrecto. Por favor verificar",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        setProductResponse(response);

        setDisableButton(true);
    };

    const enablePicking = async() => {
        setLoading(true);
        const response = await enablePickingStatus(enablePickingRequest, loginUser.jwtToken);
        clearPicking();
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "Error al habilitar el picking",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        swal({
            title: "Éxito",
            text: "Picking habilitado correctamente",
            icon: "success",
            buttons: "OK"
        });

    }

    const disablePicking = async() => {
        setLoading(true);
        const response = await disablePickingStatus(enablePickingRequest, loginUser.jwtToken);
        clearPicking();
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "Error al deshabilitar el picking",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        swal({
            title: "Éxito",
            text: "Picking deshabilitado correctamente",
            icon: "success",
            buttons: "OK"
        });
    }

    const clearPicking = () => {
        setProductResponse(null);
        setQrInput("");
        setDisableButton(true);
    }

    return (
        <Box sx={{display: "flex", justifyContent: "center", alignItems: "center",  width: "100%", height: "100%", backgroundColor: "#ededed",}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: {xs: "start", sm: "center", md: "center"},
                    width: {xs: "90%", sm: "60%", md: "40%"},
                    height: "100%",
                    textAlign: "center",
                }}
            >
                {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> :
                        <Grid container spacing={1} sx={{display: "flex", justifyContent: {xs: "center", sm: "center"}, alignItems: {xs: "center", sm: "center", md: "center"}, width: "100%"}}>
                            {productResponse && productResponse.id &&
                                <>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginTop: "1.3rem", marginLeft: "10%"}}>
                                    <Typography sx={{color: "gray", fontSize: "0.6rem"}}>Número Estiba</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                    <Typography variant="body1">{productResponse.id}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{marginBottom: "0.6rem", marginLeft: "10%"}}>
                                    <Divider sx={{width: "90%"}} />
                                </Grid>
                                </>
                            }
                            {productResponse && productResponse.warehouseProduct && productResponse.warehouseProduct.description &&
                                <>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginTop: "0.1rem", marginLeft: "10%"}}>
                                    <Typography sx={{color: "gray", fontSize: "0.6rem"}}>Descripción</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                    <Typography variant="body1">{productResponse.warehouseProduct.description}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{marginBottom: "0.6rem", marginLeft: "10%"}}>
                                    <Divider sx={{width: "90%"}} />
                                </Grid>
                                </>
                            }
                            {/* {productResponse && productResponse.level &&
                                <>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginTop: "0.1rem", marginLeft: "10%"}}>
                                    <Typography sx={{color: "gray", fontSize: "0.6rem"}}>Niveles</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                    <Typography variant="body1">{productResponse.level}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{marginBottom: "0.6rem", marginLeft: "10%"}}>
                                    <Divider sx={{width: "90%"}} />
                                </Grid>
                                </>
                            } */}
                            {productResponse && (productResponse.productAmount || productResponse.productAmount === 0) &&
                                <>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                    <Typography sx={{color: "gray", fontSize: "0.6rem"}}>Cantidad</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                    <Typography variant="body2">{new Intl.NumberFormat('es-CO').format(productResponse.productAmount)}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{marginLeft: "10%"}}>
                                    <Divider sx={{width: "90%"}} />
                                </Grid>
                                </>
                            }
                            {productResponse && productResponse.batchCode &&
                                <>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginTop: "0.1rem", marginLeft: "10%"}}>
                                    <Typography sx={{color: "gray", fontSize: "0.6rem"}}>Lote</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                    <Typography variant="body1">{productResponse.batchCode}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{marginBottom: "0.6rem", marginLeft: "10%"}}>
                                    <Divider sx={{width: "90%"}} />
                                </Grid>
                                </>
                            }
                            {productResponse && productResponse.expirationDate &&
                                <>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginTop: "0.1rem", marginLeft: "10%"}}>
                                    <Typography sx={{color: "gray", fontSize: "0.6rem"}}>Fecha Vencimiento</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                    <Typography variant="body1">{`${new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(productResponse.expirationDate))}`}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{marginBottom: "0.6rem", marginLeft: "10%"}}>
                                    <Divider sx={{width: "90%"}} />
                                </Grid>
                                </>
                            }
                            {productResponse && productResponse.pickingStatus &&    
                                <>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginTop: "0.1rem", marginLeft: "10%"}}>
                                    <Typography sx={{color: "gray", fontSize: "0.6rem"}}>Estado Picking</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                    <Typography variant="body1">{productResponse.pickingStatus === "enabled" ? "Habilitado" : "Deshabilitado"}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{marginBottom: "0.6rem", marginLeft: "10%"}}>
                                    <Divider sx={{width: "90%"}} />
                                </Grid>
                                </>
                            }
                            {productResponse && productResponse.pickingStatus &&
                                <>
                                {productResponse.pickingStatus === "disabled" &&
                                <Grid item xs={12} sx={{display: "flex", justifyContent: "center", marginTop: "1rem", marginBottom: "1rem"}}>
                                    <Button onClick={enablePicking} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                        Habilitar Picking
                                    </Button>
                                </Grid>
                                }
                                {productResponse.pickingStatus === "enabled" &&
                                <Grid item xs={12} sx={{display: "flex", justifyContent: "center", marginTop: "1rem", marginBottom: "1rem"}}>
                                    <Button onClick={disablePicking} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                        Deshabilitar Picking
                                    </Button>
                                </Grid>
                                }
                                </>
                            }
                            {productResponse &&
                                <Grid item xs={12} sx={{display: "flex", justifyContent: "center", marginTop: "1rem", marginBottom: "1rem"}}>
                                    <Button onClick={clearPicking} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                        Atrás
                                    </Button>
                                </Grid>

                            }
                            {!productResponse &&
                                <>
                                <Grid item xs={12} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "0.2rem"}}>
                                    <TextField
                                        sx={{width: "80%"}}
                                        variant="standard"
                                        fullWidth={true}
                                        id="qrInput"
                                        name="qrInput"
                                        label={<Typography variant="body2">Código Estiba</Typography>}
                                        value={qrInput}
                                        onChange={(e)=> qrInputChange(e)}
                                        autoComplete="off"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", marginTop: "1rem", marginBottom: "1rem"}}>
                                    <Button onClick={qrInputSubmit} variant="contained" disabled={disableButton} sx={{backgroundColor: Colors.primary,}}>
                                        Buscar
                                    </Button>
                                </Grid>
                                </>
                            }
                        </Grid>
                }
            </Box>
        </Box>
    )
}
